import React from 'react';
import teslaTop from '../../../images/teslaTop.png';
import '../LandingPageNYC/landingPageNYC.css';
import MobileLeftSF from './AutzuProMobileLeftSF';

const AutzuEvMobileSF = () => (
  <div className="nyc-vehicle-types__column nyc-vehicle-types__column--justify-left">
    <MobileLeftSF />
    <div className="toronto-vehicle-types__vehicles--mobile">
      <img
        className={'toronto-vehicle-types__car-image'}
        src={teslaTop}
        alt="ProTopViewGraphic"
      />
    </div>
  </div>
);

export default AutzuEvMobileSF;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/AutzuEvMobileSF.js